import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, RadioButton } from "../../primary";
import editIcon from "../../../static/images/edit-icon.png";
import { woundClassificationAsync, getclassificationAsync, ne1updateassessmentclassificationAsync } from "../../../app/patientSlice";
import { CloseWarning } from "../../secondary";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { allNullCheck, signedLockedAccess } from "../../../utils";
import { enableCheckerMove, handleFirstMove } from "../../../utils/productsHelper";
import infoIcon from "../../../static/images/info.svg";
import { Confirmation } from "../../secondary/Confirmation/confirmation";
import warning from "../../../static/images/icon-check-danger.png";
import { useNavigate } from "react-router-dom";
import { ReadOnlyBanner } from "../../secondary/ReadOnlyBanner/ReadOnlyBanner";

/* ── PI Images ── */
import classificationPiClosed1 from "../../../static/images/classification_PI_Images/closed/1.jpg";
import classificationPiClosed2 from "../../../static/images/classification_PI_Images/closed/2.jpg";
import classificationPiClosed3 from "../../../static/images/classification_PI_Images/closed/3.jpg";
import classificationPiPrestage1 from "../../../static/images/classification_PI_Images/prestage1/1.jpg";
import classificationPiPrestage2 from "../../../static/images/classification_PI_Images/prestage1/2.jpg";
import classificationPiPrestage3 from "../../../static/images/classification_PI_Images/prestage1/3.jpg";
import classificationPiStageFirst1 from "../../../static/images/classification_PI_Images/stage1/1.jpg";
import classificationPiStageFirst2 from "../../../static/images/classification_PI_Images/stage1/2.jpg";
import classificationPiStageFirst3 from "../../../static/images/classification_PI_Images/stage1/3.jpg";
import classificationPiStageSecond1 from "../../../static/images/classification_PI_Images/stage2/1.jpg";
import classificationPiStageSecond2 from "../../../static/images/classification_PI_Images/stage2/2.jpg";
import classificationPiStageSecond3 from "../../../static/images/classification_PI_Images/stage2/3.jpg";
import classificationPiStageThird1 from "../../../static/images/classification_PI_Images/stage3/1.jpg";
import classificationPiStageThird2 from "../../../static/images/classification_PI_Images/stage3/2.jpg";
import classificationPiStageThird3 from "../../../static/images/classification_PI_Images/stage3/3.jpg";
import classificationPiStageFourth1 from "../../../static/images/classification_PI_Images/stage4/1.jpg";
import classificationPiStageFourth2 from "../../../static/images/classification_PI_Images/stage4/2.jpg";
import classificationPiStageFourth3 from "../../../static/images/classification_PI_Images/stage4/3.jpg";
import classificationPiDtpi1 from "../../../static/images/classification_PI_Images/dtpi/1.jpg";
import classificationPiDtpi2 from "../../../static/images/classification_PI_Images/dtpi/2.jpg";
import classificationPiDtpi3 from "../../../static/images/classification_PI_Images/dtpi/3.jpg";
import classificationPiUnstageable1 from "../../../static/images/classification_PI_Images/unsatgeable/1.jpg";
import classificationPiUnstageable2 from "../../../static/images/classification_PI_Images/unsatgeable/2.jpg";
import classificationPiUnstageable3 from "../../../static/images/classification_PI_Images/unsatgeable/3.jpg";
import classificationPiMmpi1 from "../../../static/images/classification_PI_Images/mmpi/1.jpg";
import classificationPiMmpi2 from "../../../static/images/classification_PI_Images/mmpi/2.jpg";
import classificationPiMmpi3 from "../../../static/images/classification_PI_Images/mmpi/3.jpg";

/* ── Other Images ── */
import classiOtherClosed1 from "../../../static/images/classification_Other_Images/Closed/1.jpg";
import classiOtherClosed2 from "../../../static/images/classification_Other_Images/Closed/2.jpg";
import classiOtherClosed3 from "../../../static/images/classification_Other_Images/Closed/3.jpg";
import classiOtherClosed4 from "../../../static/images/classification_Other_Images/Closed/4.jpg";
import classiOtherClosed5 from "../../../static/images/classification_Other_Images/Closed/5.jpg";
import classiOtherClosed6 from "../../../static/images/classification_Other_Images/Closed/6.jpg";
import classiOtherSuperFicial1 from "../../../static/images/classification_Other_Images/Superficial/1.jpg";
import classiOtherSuperFicial2 from "../../../static/images/classification_Other_Images/Superficial/2.jpg";
import classiOtherSuperFicial3 from "../../../static/images/classification_Other_Images/Superficial/3.jpg";
import classiOtherSuperFicial4 from "../../../static/images/classification_Other_Images/Superficial/4.jpg";
import classiOtherSuperFicial5 from "../../../static/images/classification_Other_Images/Superficial/5.jpg";
import classiOtherSuperFicial6 from "../../../static/images/classification_Other_Images/Superficial/6.jpg";
import classiOtherParitcalThick1 from "../../../static/images/classification_Other_Images/ParticalThickness/1.jpg";
import classiOtherParitcalThick2 from "../../../static/images/classification_Other_Images/ParticalThickness/2.jpg";
import classiOtherParitcalThick3 from "../../../static/images/classification_Other_Images/ParticalThickness/3.jpg";
import classiOtherParitcalThick4 from "../../../static/images/classification_Other_Images/ParticalThickness/4.jpg";
import classiOtherParitcalThick5 from "../../../static/images/classification_Other_Images/ParticalThickness/5.jpg";
import classiOtherParitcalThick6 from "../../../static/images/classification_Other_Images/ParticalThickness/6.jpg";
import classiOtherFullThick1 from "../../../static/images/classification_Other_Images/FullThickness/1.jpg";
import classiOtherFullThick2 from "../../../static/images/classification_Other_Images/FullThickness/2.jpg";
import classiOtherFullThick3 from "../../../static/images/classification_Other_Images/FullThickness/3.jpg";
import classiOtherFullThick4 from "../../../static/images/classification_Other_Images/FullThickness/4.jpg";
import classiOtherFullThick5 from "../../../static/images/classification_Other_Images/FullThickness/5.jpg";
import classiOtherFullThick6 from "../../../static/images/classification_Other_Images/FullThickness/6.jpg";
import Tooltip from "../../secondary/Tooltip/tooltip";
import { PERMISSIONS } from "../../../constants/permissions";

const RADIO_ROW_KEYS = ["nonremovabledressingdevice", "unabletodeterminewoundclassification", "woundcannotbestaged"];

const PI_IMAGES = {
  closed: [classificationPiClosed1, classificationPiClosed2, classificationPiClosed3],
  prestage1blanchableerythemia: [classificationPiPrestage1, classificationPiPrestage2, classificationPiPrestage3],
  stage1: [classificationPiStageFirst1, classificationPiStageFirst2, classificationPiStageFirst3],
  stage2: [classificationPiStageSecond1, classificationPiStageSecond2, classificationPiStageSecond3],
  stage3: [classificationPiStageThird1, classificationPiStageThird2, classificationPiStageThird3],
  stage4: [classificationPiStageFourth1, classificationPiStageFourth2, classificationPiStageFourth3],
  dtpideeptissuepressureinjuryulcermayevolveorresolve: [classificationPiDtpi1, classificationPiDtpi2, classificationPiDtpi3],
  unstageable: [classificationPiUnstageable1, classificationPiUnstageable2, classificationPiUnstageable3],
  mmpimucosal: [classificationPiMmpi1, classificationPiMmpi2, classificationPiMmpi3],
};

const PI_SUBTITLES = {
  prestage1blanchableerythemia: "(Blanchable Skin)",
  stage1: "(Non-Blanchable Skin)",
  dtpideeptissuepressureinjuryulcermayevolveorresolve: "(Deep Tissue Pressure Injury)",
  mmpimucosal: "(Mucosal Membrane Pressure Injury)",
};

const OTHER_IMAGES_ROW1 = {
  closed: [classiOtherClosed1, classiOtherClosed2, classiOtherClosed3],
  superficial: [classiOtherSuperFicial1, classiOtherSuperFicial2, classiOtherSuperFicial3],
  partialthickness: [classiOtherParitcalThick1, classiOtherParitcalThick2, classiOtherParitcalThick3],
  fullthickness: [classiOtherFullThick1, classiOtherFullThick2, classiOtherFullThick3],
};

const OTHER_IMAGES_ROW2 = {
  closed: [classiOtherClosed4, classiOtherClosed5, classiOtherClosed6],
  superficial: [classiOtherSuperFicial4, classiOtherSuperFicial5, classiOtherSuperFicial6],
  partialthickness: [classiOtherParitcalThick4, classiOtherParitcalThick5, classiOtherParitcalThick6],
  fullthickness: [classiOtherFullThick4, classiOtherFullThick5, classiOtherFullThick6],
};

function InfoTooltip({ info, listStyle = false, styles }) {
  if (!info) return null;
  return (
    <span className={`${styles.tooltip}${listStyle ? styles.tooltip_list : ""}`}>
      <img
        src={infoIcon}
        alt="info"
        style={{ fontSize: "16px", width: "26px", height: "auto", paddingLeft: "3px", paddingRight: "5px", color: "#0052cc" }}
      />
      <span className={listStyle ? styles.tooltiptext : styles.tooltiptextOther}>{info}</span>
    </span>
  );
}

export function CharacteristicClassification({
  index,
  updateDone,
  patientId,
  assessmentId,
  selectedIndex,
  assessmentDetails,
  getCharDetails,
  styles,
  overrideToggle,
  isCompleted,
  historyCauseCompleted,
  characteristicTabsData,
  isReadOnly,
  hasPermission,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { register, errors, handleSubmit, reset, getValues, setValue } = useForm({ mode: "onSubmit" });

  const woundClassificationOptions = useSelector((s) => s.patient.woundClassificationOptions);
  const classificationData = useSelector((s) => s.patient.classificationDataByAssessID);
  const charStatus = useSelector((s) => s.patient.charStatus);

  const [editable, setEditable] = useState(false);
  const [formChangesConfirm, setFormChangesConfirm] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);
  const [closeWarning, setCloseWarning] = useState(false);
  const [assessmentDetailsNew, setAssessmentDetailsNew] = useState("");
  const [displayFirst, setDisplayFirst] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [showState, setShowState] = useState(false);
  const [noTissueTypes, setNoTissueTypes] = useState(false);
  const [errorShowing, setErrorShowing] = useState(false);
  const [toggleOn, setToggleOn] = useState(false);

  const [selectedKey, setSelectedKey] = useState("");

  const selectedIsRadio = RADIO_ROW_KEYS.includes(selectedKey);
  const isSignedLocked = !signedLockedAccess(assessmentDetails?.assessmentStage);

  useEffect(() => {
    reset({});
    toast.dismiss("success1");
    dispatch(getclassificationAsync({ patientId, assessmentId, type: "tissuetypes" }, navigate));
  }, []); // eslint-disable-line

  useEffect(() => {
    if (!classificationData) return;
    if (isCompleted === 0) {
      setAssessmentDetailsNew("");
      setEditable(true);
    } else {
      setAssessmentDetailsNew({ classification: classificationData?.classifications });
    }
  }, [classificationData, isCompleted]);

  useEffect(() => {
    if (!assessmentDetails) return;
    const identifiable = assessmentDetails.classification === null ? null : assessmentDetails.classification?.woundBedIdentifiable;
    callDispatcher(identifiable, assessmentDetails.classification === null ? 1 : 0);
  }, [assessmentDetails]); // eslint-disable-line

  useEffect(() => {
    const saved = assessmentDetailsNew?.classification?.woundClassification;
    if (!saved || saved === "Unknown" || saved === "unknown") {
      setSelectedKey("");
    } else {
      setSelectedKey(saved);
    }
  }, [assessmentDetailsNew]);

  useEffect(() => {
    if (isSignedLocked) return;
    const wc = assessmentDetailsNew?.classification?.woundClassification;
    if (wc === "Unknown" || wc === "unknown") {
      setEditable(true);
      setSelectedKey("");
    }
  }, [assessmentDetailsNew]); // eslint-disable-line

  useEffect(() => {
    assessmentDetails?.tissueTypes?.forEach((d) => {
      if (d.id >= 1 && d.id <= 33) setDisplayFirst(true);
    });
  }, []); // eslint-disable-line

  useEffect(() => {
    enableCheckerMove(woundClassificationOptions?.result, setEnabled);
  }, [woundClassificationOptions?.result]);

  useEffect(() => {
    if (selectedKey) setErrorShowing(false);
  }, [selectedKey]);

  useEffect(() => {
    if (selectedIsRadio) setToggleOn(false);
  }, [selectedIsRadio]);

  useEffect(() => {
    if (!editable) return;
    if (formChangesConfirm && clickCancel) {
      setConfirmationModal(true);
    } else if (clickCancel && !formChangesConfirm) {
      setClickCancel(false);
      setEditable(false);
    }
  }, [formChangesConfirm, clickCancel, editable]);

  const callDispatcher = (identifiable, config) => {
    dispatch(
      woundClassificationAsync({
        patientId,
        assessmentId,
        data: { woundBedIdentifiable: identifiable, configurationRequest: config },
        overrideenable: toggleOn,
      })
    );
  };

  const handleFirst = (e) => {
    setFormChangesConfirm(true);
    if (e.target.value !== "") setShowState(true);
    handleFirstMove(e.target.value, reset, getValues, callDispatcher);
  };

  const restoreFromSaved = () => {
    const saved = assessmentDetailsNew?.classification?.woundClassification;
    setSelectedKey(!saved || saved === "Unknown" || saved === "unknown" ? "" : saved);
    setCloseWarning(false);
  };

  const selectOption = (key) => {
    setFormChangesConfirm(true);
    setSelectedKey((prev) => (prev === key ? "" : key));
  };

  const isOptionEnabled = (data) => data.enable === 1 || (data.enable === 0 && toggleOn);

  const onSubmit = (data) => {
    if (assessmentDetails?.tissueTypes === null) {
      setNoTissueTypes(true);
      setTimeout(() => setNoTissueTypes(false), 5000);
      return;
    }
    if (enabled && !selectedKey) {
      setErrorShowing(true);
      return;
    }
    setErrorShowing(false);

    const navigateNext = () => {
      updateDone(index);
      if (Array.isArray(charStatus) && charStatus[index] === 1) {
        setEditable(false);
      } else {
        selectedIndex(index + 1);
      }
    };

    dispatch(
      ne1updateassessmentclassificationAsync(
        {
          patientId,
          assessmentId,
          assessment: {
            ...assessmentDetails,
            classification: {
              woundBedIdentifiable: data.woundBedIdentifiable ? (data.woundBedIdentifiable === "Yes" ? 1 : 0) : null,
              woundClassification: selectedKey || null,
            },
          },
          navigate: navigateNext,
          getCharDetails,
          overrideenable: overrideToggle ? 1 : 0,
        },
        navigateNext
      )
    );
  };

  const confirmationClose = () => {
    setConfirmationModal(false);
    setClickCancel(false);
  };

  const yesConfirmationModalClick = () => {
    restoreFromSaved();
    setConfirmationModal(false);
    setEditable(false);
    setFormChangesConfirm(false);
    setClickCancel(false);
  };

  const getCardClass = (data, isPi) => {
    const base = isPi ? `col-lg-4 col-md-6 col-sm-12 ${styles.hoverCard}` : `${styles.hoverCardOther} col-5 col-push-2`;
    const isEnabled = isOptionEnabled(data);
    const isSelected = selectedKey === data.key && !selectedIsRadio;

    if (!isEnabled) {
      return `${base} ${styles.disabled} pt-4 px-0${isSelected ? ` ${styles.selectedFile}` : ""}`;
    }
    if (isSelected) {
      return `${base} ${styles.notdisabled} ${styles.selectedSingleFile} pt-4 px-0`;
    }
    return `${base} ${styles.notdisabled} pt-4 px-0`;
  };

  const getRadioRowClass = (data, colWidth) => {
    const isEnabled = isOptionEnabled(data);
    const isSelected = selectedKey === data.key;
    const base = isEnabled ? styles.cardRadio : styles.cardRadioDisabled;
    return `${base} col-${colWidth}${isSelected ? ` ${styles.selectedFileRadio}` : ""}`;
  };

  const isPiCategory =
    assessmentDetails?.historyCause?.causeCategory === "pi" || assessmentDetails?.historyCause?.causeCategory === "unabletodetermine";

  const showWoundStage =
    showState ||
    (woundClassificationOptions?.isWoundBedIdentifiedQuestionShow !== 1 && assessmentDetails?.tissueTypes !== null) ||
    assessmentDetailsNew?.classification?.woundBedIdentifiable === 1 ||
    assessmentDetailsNew?.classification?.woundBedIdentifiable === 0;

  const renderOverrideToggle = (extraClass = "") => (
    <div className="text-right custom-control custom-switch pl-0 pt-2">
      <div className={`${styles.toggle_shells_class} ${extraClass} text-right d-flex`}>
        <div className={`${styles.toggle_button_status} pr-5`} style={{ fontWeight: "500", fontSize: "17px" }}>
          Override:{" "}
        </div>
        <input
          type="checkbox"
          name="toggle"
          className="custom-control-input"
          id="toggleSwitch"
          data-testid="toggleSwitch"
          checked={toggleOn}
          disabled={selectedIsRadio}
          onChange={() => setToggleOn((v) => !v)}
        />
        <label className={`custom-control-label ${styles.toggle_switch} ${extraClass}`} htmlFor="toggleSwitch" />
      </div>
    </div>
  );

  const renderImageCards = (isPi) => {
    const row1 = isPi ? PI_IMAGES : OTHER_IMAGES_ROW1;
    const row2 = isPi ? null : OTHER_IMAGES_ROW2;

    return (
      <div className={`row${isPi ? "" : " justify-content-start ml-3"}`}>
        {woundClassificationOptions?.result
          ?.filter((f) => !RADIO_ROW_KEYS.includes(f.key))
          ?.map((data, idx) => {
            const isEnabled = isOptionEnabled(data);
            return (
              <div
                key={idx}
                className={getCardClass(data, isPi)}
                style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
                onClick={() => {
                  if (isEnabled) selectOption(data.key);
                }}
              >
                <InfoTooltip info={data.info} styles={styles} />

                <div className="p-0">
                  <div className={`${styles.woundImagecard} text-center`}>
                    {(row1[data.key] || []).map((src, i) => (
                      <img key={i} src={src} className={styles.imgCard} alt="woundImage" />
                    ))}
                  </div>
                  {row2 && (
                    <div className={`${styles.woundImagecard} ${styles.woundImagecardExtra} text-center`}>
                      {(row2[data.key] || []).map((src, i) => (
                        <img key={i} src={src} className={styles.imgCard} alt="woundImage" />
                      ))}
                    </div>
                  )}
                  {isPi ? (
                    <>
                      <div className={PI_SUBTITLES[data.key] ? styles.cardHeadingResVal : styles.cardHeading}>
                        <h3>{data.value}</h3>
                      </div>
                      {PI_SUBTITLES[data.key] && (
                        <div className={styles.cardSubheading}>
                          <p>{PI_SUBTITLES[data.key]}</p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className={`${styles.cardHeading} pb-3`}>
                      <h3>{data.value}</h3>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  const renderRadioRows = (colWidth) =>
    RADIO_ROW_KEYS.map((key, i) => {
      const data = woundClassificationOptions?.result?.find((r) => r.key === key);
      if (!data) return null;
      const isEnabled = isOptionEnabled(data);
      const isSelected = selectedKey === key;

      return (
        <div key={i} className={`row pt-4 pb-3`}>
          <div
            className={getRadioRowClass(data, colWidth)}
            style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
            onClick={() => {
              if (isEnabled) selectOption(data.key);
            }}
          >
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <span
                  style={{
                    display: "inline-block",
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    border: `2px solid ${isEnabled ? "#0052cc" : "#aaa"}`,
                    backgroundColor: isSelected ? "#0052cc" : "transparent",
                    flexShrink: 0,
                    marginRight: "8px",
                    pointerEvents: "none",
                  }}
                />
                <h3 style={{ marginBottom: 0 }}>{data.value}</h3>
              </div>
              <Tooltip width="415px" placement="left" content={data.info}>
                <img src={infoIcon} alt="info" style={{ width: 18 }} />
              </Tooltip>
            </div>
          </div>
        </div>
      );
    });

  const renderActionButtons = () => (
    <div className="mt-4 offset-4">
      {noTissueTypes && <div className="text-danger">Review Tissue Types before classifying the wound.</div>}
      {isCompleted === 0 ? (
        <Button type="submit" value="Next" classes={{ className: `btn btn-small ml-4 ${styles.btn_small} ${styles.btn_custom}` }} id="save" disabled={isSignedLocked} />
      ) : (
        <>
          <Button type="submit" value="Save" classes={{ className: `btn btn-small ml-0 mr-4 ${styles.btn_small} ${styles.btn_custom}` }} id="save" disabled={isSignedLocked} />
          <Button
            type="button"
            value="Cancel"
            classes={{ className: `btn btn-small ${styles.btn_small_cancel} ${styles.btn_custom} ml-2` }}
            id="cancel"
            onClick={() => setClickCancel(true)}
            disabled={isSignedLocked}
          />
        </>
      )}
    </div>
  );

  //  Final Render
  return (
    <>
      {confirmationModal && (
        <Confirmation onClose={confirmationClose} title=" ">
          <div className="text-center pr-5 pl-5">
            <p>
              <img src={warning} alt="warning-icon" />
            </p>
            <p className="pb-3">All progress in this section will be lost. Are you sure want to cancel?</p>
            <div className="mb-2">
              <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${styles.yes_btn}` }} onClick={yesConfirmationModalClick} />
              <Button id="closeId" value="No" classes={{ className: `btn ml-2 pb-2 pt-2 ${styles.no_btn}` }} onClick={confirmationClose} />
            </div>
          </div>
        </Confirmation>
      )}

      <div className={`${styles.mesurement_blk} p-0`}>
        {isReadOnly && <ReadOnlyBanner />}
        <div>
          {/* ════ VIEW ════ */}
          {!editable ? (
            <>
                <button
                  className={`float-sm-right ${styles.tab_edit}`}
                  disabled={isReadOnly || !hasPermission(PERMISSIONS.CHARACTERISTIC_CLASSIFICATION_EDIT) || isSignedLocked}
                  onClick={() => {
                    setEditable(true);
                    setTimeout(() => {
                      const wbi = assessmentDetailsNew?.classification?.woundBedIdentifiable;
                      if (wbi != null) handleFirstMove(wbi === 1 ? "Yes" : "No", reset, getValues, callDispatcher);
                      setValue("woundBedIdentifiable", wbi === 1 ? "Yes" : wbi === 0 ? "No" : "");
                      setValue("woundClassification", assessmentDetailsNew?.classification?.woundClassification || "");
                    }, 100);
                  }}
                >
                  <img src={editIcon} alt="edit" />
                  Edit
                </button>

              {woundClassificationOptions?.isWoundBedIdentifiedQuestionShow === 1 && (
                <p>
                  <label>Can the wound bed be identified? </label>
                  <span>{assessmentDetailsNew?.classification?.woundBedIdentifiable === 1 ? "Yes" : "No"}</span>
                </p>
              )}

              <p>
                <label>Wound stage:</label>
                <span>
                  {allNullCheck(assessmentDetailsNew?.classification?.woundClassification)
                    ? woundClassificationOptions?.result?.find((d) => d.key === assessmentDetailsNew?.classification?.woundClassification)?.value
                    : "-"}
                </span>
              </p>
            </>
          ) : (
            /* ════ EDIT ════ */
            <>
              {closeWarning && (
                <CloseWarning
                  message="All progress in this section will be lost. Are you sure want to cancel?"
                  yesFn={restoreFromSaved}
                  noFn={() => setCloseWarning(false)}
                />
              )}

              {historyCauseCompleted === 0 ? (
                <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>
                  Please select History/Cause before selecting Classification
                </div>
              ) : characteristicTabsData?.find((item) => item?.key === "tissuetype")?.isCompleted === 0 ? (
                <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>
                  Please select Tissue Type(s) before selecting Classification
                </div>
              ) 
               : (
                <div className="container-fluid p-0 ftest">
                  <div className={`${styles.patient_content} p-0`}>
                    <Form setFormChangesConfirm={setFormChangesConfirm} formChanges className="col-12" onSubmit={handleSubmit(onSubmit)} requiredPermission={PERMISSIONS.ASSESSMENT} disabled={isSignedLocked}>
                      {((assessmentDetails?.tissueTypes !== null && displayFirst) ||
                        woundClassificationOptions?.isWoundBedIdentifiedQuestionShow === 1) && (
                        <div className={woundClassificationOptions?.isWoundBedIdentifiedQuestionShow === 1 ? `col-12 ${styles.col_spec}` : "d-none"}>
                          {woundClassificationOptions?.isWoundBedIdentifiedQuestionShow === 1 && (
                            <>
                              <label className={`col-4 col-form-label ${styles.label_spec} pl-3`}>
                                Can the wound bed be identified? <span style={{ color: "#de350b" }}>*</span>
                              </label>
                              <div className="col-6 p-0">
                                <RadioButton
                                  id="woundBedIdentifiable"
                                  name="woundBedIdentifiable"
                                  classes={{
                                    labelClass: `custom-control-label col-form-label ${styles.custom_control_label}`,
                                    inputClassName: `custom-control-input ${styles.custom_control_input}`,
                                    inputColumn: "custom-control custom-radio custom-control-inline",
                                  }}
                                  radioOption={["Yes", "No"]}
                                  validator={register({ required: "Please select Yes or No" })}
                                  errors={errors}
                                  onChange={handleFirst}
                                  defaultValue={
                                    assessmentDetailsNew?.classification?.woundBedIdentifiable === 1
                                      ? "Yes"
                                      : assessmentDetailsNew?.classification?.woundBedIdentifiable === 0
                                      ? "No"
                                      : ""
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      )}

                      {assessmentDetails?.tissueTypes !== null && (isPiCategory ? showWoundStage : true) && (
                        <div className={isPiCategory ? "col-12 pt-1" : "col-12 pt-2 pl-5 ml-4"}>
                          <div className={`row pb-3${isPiCategory ? "" : " ml-0"}`}>
                            <div className={`${isPiCategory ? "col-12" : "col-10 ml-4"} d-flex justify-content-between`}>
                              <label className={`col-form-label ${styles.label_spec}`}>
                                Wound stage: <span style={{ color: "#de350b" }}>*</span>
                              </label>
                              {renderOverrideToggle(isPiCategory ? styles.toggle_shells_class_special : "")}
                            </div>
                          </div>

                          {renderImageCards(isPiCategory)}

                          {renderRadioRows(isPiCategory ? 12 : 10)}

                          <div className={`col-12 pt-${isPiCategory ? "4" : "3"} text-center`}>
                            {errorShowing && (
                              <span
                                className={`text-danger${isPiCategory ? "" : " ml-n5"}`}
                                style={{ fontFamily: "open_sansregular", fontSize: "16px" }}
                              >
                                Please select the wound stage
                              </span>
                            )}
                          </div>

                          {renderActionButtons()}
                        </div>
                      )}
                    </Form>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
